export const isDigitalQuoteDomain = () =>
  ~(location.hostname || '').indexOf('digital-quote.com');
